// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getFailureModes} from '../../shared/repositories';

export const readFailureModes = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const claimTypeKey = 'ZZTK';
            const data = await getFailureModes(claimTypeKey);

            dispatch({
                data,
                type: actions.UPDATE_CLAIM_TRACK_FAILURE_MODE_COLLECTION
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/track/action-creators/failure-modes.js